import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getPaginationInitial } from "../../state/modules/search/selectors.js";

const useCurrentPage = () => useSelector(getPaginationInitial);
export const MetaRobots = () => {
  const currentPage = useCurrentPage();

  useEffect(() => {
    if (currentPage > 1) {
      const metaTag = document.createElement("meta");
      metaTag.name = "robots";
      metaTag.content = "nosnippet";
      document.head.appendChild(metaTag);

      return () => {
        document.head.removeChild(metaTag);
      };
    }
  }, [currentPage]);

  return null;
};
